import { Injectable } from '@angular/core';
import { Step } from '../shared/step.model';

@Injectable({
  providedIn: 'root',
})
export class StepsService {

  getSteps(loanPurpose: string, isFullFastFlow: boolean = false): Step[] {

    loanPurpose = loanPurpose.toLowerCase();
    if (loanPurpose === 'airatefinder') {
      return [new Step('loanPurpose')];
    }

    const contactSteps = [new Step('firstNameLastName'), new Step('email', null, 'setBackgroundImage'), new Step('phone')];

    const allSteps = {
      refinance: [
        new Step('propertyType'),
        new Step('propertyTypeConfirmation', 'propertyTypeConfirmation'),
        new Step('propertyUse'),
        // new Step('bankruptcy'),
        // new Step('selfEmployed'),
        new Step('maximumEquity', 'maximumEquity'),
        new Step('cashOut', 'showCashOut'),
        new Step('cashOutReason', 'cashOutReason'),
        new Step('propertyValue'),
        new Step('firstMortgageBalance'),
        new Step('currentFHA', 'currentFHA'),
        new Step('creditRating'),
        new Step('zipCodeStreetAddress'),
        new Step('veteranMilitary'),
        new Step('currentVA', 'currentVA'),
        // new Step('lendersCount'),
        ...contactSteps,
        new Step('neustar', 'neustar')
      ],
      purchase: [
        new Step('propertyType'),
        new Step('propertyTypeConfirmation', 'propertyTypeConfirmation'),
        new Step('propertyUse'),
        // new Step('bankruptcy'),
        // new Step('bankruptcy-recency', 'bankruptcyRecency'),
        // new Step('selfEmployed'),
        new Step('buyingProcess'),
        new Step('newHomeValue'),
        new Step('creditRating'),
        new Step('estimatedDownPayment'),
        new Step('zipCode'),
        new Step('veteranMilitary'),
        new Step('firstTimeBuyer'),
        // new Step('lendersCount'),
        ...contactSteps,
        new Step('neustar', 'neustar')
      ],
      personalloan: [
        new Step('loanPurpose'),
        new Step('cashOut'),
        new Step('creditRating'),
        new Step('timeFrame', 'propertyStatus'),
        new Step('zipCodeStreetAddress'),
        new Step('propertyStatus', 'propertyStatus'),// old key: 'propertyUse',
        new Step('propertyValue', 'housingSituationIsOwn'),
        new Step('firstMortgageBalance', 'housingSituationIsOwn'),
        // new Step('selfEmployed'),
        // new Step('bankruptcy'),
        new Step('veteranMilitary', 'housingSituationIsOwn'),
        new Step('currentVA', 'currentVA'),
        ...contactSteps,
        new Step('neustar', 'neustar')
      ],
      // FRU-24835: the reverse mortgage flow (LoanPurpose=refinance&FormType=reverse), after LendingTree's short set: the
      // youngest borrower's age, property type, primary residence, value, balance, ZIP and street, then contact. Credit stays
      // in, as in every other flow, because buyers' lead filters read it.
      reverse: [
        new Step('reverseAge'),
        new Step('propertyType'),
        new Step('reverseResidence'),
        new Step('propertyValue'),
        new Step('reverseBalance'),
        new Step('creditRating'),
        new Step('zipCodeStreetAddress'),
        ...contactSteps,
        new Step('neustar', 'neustar')
      ],
      pl: [
        new Step('creditRating'),
        new Step('propertyStatus', 'propertyStatus'),
        ...contactSteps,
        new Step('neustar', 'neustar')
      ]
    };

    return allSteps[loanPurpose];
  }
}
